import {
  DataTablePrimeReact,
  IColumnProps,
  TableERP,
} from "@finanedi.es/storybook"
import { GetPrestamoByFiltersDtoProps } from "api/DTOs/GetPrestamoByFiltersDto"
import { DataTableRowClickEventParams } from "primereact/datatable"
import { RefObject } from "react"
import { useTranslation } from "react-i18next"

export interface TablePrestamosProps {
  columns: IColumnProps[]
  refTable: RefObject<DataTablePrimeReact<GetPrestamoByFiltersDtoProps[]>>
  value: Array<GetPrestamoByFiltersDtoProps>
  loading: boolean
  onRowClick?: ({
    data,
    originalEvent: { target },
  }: DataTableRowClickEventParams) => void
  selection: GetPrestamoByFiltersDtoProps[]
  onSelectionChange: (e: { value: GetPrestamoByFiltersDtoProps[] }) => void
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
  footer?: JSX.Element
}

const TablePrestamos = ({
  columns,
  refTable,
  value,
  loading,
  onRowClick,
  selection,
  onSelectionChange,
  onSort,
  sortField,
  sortOrder,
  footer,
}: TablePrestamosProps) => {
  const { t } = useTranslation()
  return (
    <TableERP
      refTable={refTable}
      data-testid='tabla-prestamos'
      id='tabla-prestamos'
      className='tw-h-full !tw-z-0'
      dataKey='id'
      value={value}
      loading={loading}
      columns={columns}
      selectionMode='checkbox'
      selectionColumnMode='multiple'
      onSort={onSort}
      sortField={sortField}
      sortOrder={sortOrder}
      onRowClick={onRowClick}
      selection={selection}
      onSelectionChange={onSelectionChange}
      removableSort
      lazy
      scrollable
      emptyMessage={t("primeReact.table.emptyMessage")}
      footerColumnGroup={footer}
    />
  )
}

export default TablePrestamos
